import { Grid, Typography, IconButton } from '@mui/material';
import { MoreHorizRounded } from '@mui/icons-material';
import styles from './styles';
import Div from '../../../../../shared/ui/Div';
import React, { FC } from 'react';
import { LingoLiftManageClassTeacherItemDropDownMenu } from "../../../../../features/lingoLiftClasses";

interface ITeacherItemProps {
  id: number;
  firstName?: string;
  lastName?: string;
  email: string;
  role: string;
  classTeacherId?: number;
  onDeleteTeacher?: () => void;
  isPrimaryTeacher: boolean;
  isCurrentTeacherPrimary: boolean;
}

const ManageTeacherItem: FC<ITeacherItemProps> = props => {
  const { firstName, lastName, email, onDeleteTeacher, isPrimaryTeacher, isCurrentTeacherPrimary } = props;
  const isActionable = !isPrimaryTeacher && isCurrentTeacherPrimary && onDeleteTeacher;

  return (
    <Div sx={styles.container}>
      <Grid container spacing={4}>
        <Grid xs={12} sm={3} item sx={styles.column}>
          <Typography sx={styles.linkItem}>
            {lastName}, {firstName}
          </Typography>
        </Grid>
        <Grid xs={12} sm={4} item sx={styles.column}>
          <Typography>{email}</Typography>
        </Grid>
        <Grid xs={12} sm={5} sx={styles.column} item>
          {isPrimaryTeacher ? (
            <Typography sx={styles.primaryTeacherLabel}>PRIMARY</Typography>
          ) : (
            <Typography sx={styles.coTeacherLabel}>CO-TEACHER</Typography>
          )}
        </Grid>
      </Grid>
      {isActionable ? (
        <LingoLiftManageClassTeacherItemDropDownMenu {...props} />
      ) : (
        <IconButton disabled>
          <MoreHorizRounded sx={{ ...styles.dotedIcon, opacity: 0 }} />
        </IconButton>
      )}
    </Div>
  );
};

export default ManageTeacherItem;